<template>
  <div id="informacion-cuota">
    <v-dialog v-model="dialog" :max-width="700" :style="{ zIndex: 200 }">
      <v-card>
        <v-toolbar dark color="indigo" dense flat>
          <v-toolbar-title class="white--text">
            Informacion de pagos
            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              bottom
              color="gold"
            />
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-data-table
            :headers="headers"
            :items="datos"
            disable-sort
          >
            <template v-slot:[`item.fechaPago`]="{ item }">
              {{ formatDate(item.fechaPago) }}
            </template>
            <template v-slot:[`item.numeroRecibo`]="{ item }">
              {{ generarNumero(item) }}
            </template>
            <template v-slot:[`item.monto`]="{ item }">
              {{ montoMoneda(item) }}
            </template>
            <template v-slot:[`item.pdf`]="{ item }">
              <v-icon small class="mr-2" @click.stop="mostrarPdfRecibo(item)">
                mdi-file-pdf-box
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <span>
            Monto condonado: {{ simboloMoneda + ' ' + cuota.monto_condonado }}
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import GeneradorPdfRecibojs from '../mixins/generadorPdfRecibo'
  import dayjs from 'dayjs'

  export default {
    name: 'InformacionCuota',
    mixins: [GeneradorPdfRecibojs],
    props: {
      cuota: {
        type: Object,
        required: false,
        default: null,
      },
      toggle: {
        type: Boolean,
        required: true,
        default: true,
      },
      simboloMoneda: {
        type: String,
        required: true,
        default: '$',
      },
    },
    data () {
      return {
        headers: [
          { text: 'Fecha', align: 'start', sortable: true, value: 'fechaPago' },
          { text: 'Recibo numero', sortable: true, value: 'numeroRecibo' },
          { text: 'Monto', sortable: true, value: 'monto' },
          { text: 'Ver', sortable: true, value: 'pdf' },
        ],
        datosCuota: null,
        dialog: false,
        loading: true,
        datos: [],
        cuotas: [],
      }
    },
    computed: {},
    watch: {
      toggle (val) {
        this.mostrarInfo(this.cuota.id)
      },
    },
    created () {},
    methods: {
      formatDate (value) {
        return dayjs(value).format('YYYY-MM-DD')
      },
      mostrarPdfRecibo (item) {
        this.generarPdfRecibo(item.numeroRecibo)
      },
      mostrarInfo (idCuota) {
        this.loading = true
        const found = this.cuotas.find(element => element.numeroCuota === idCuota)
        this.dialog = true
        if (found === undefined) {
          this.getDatosCuota(idCuota)
        } else {
          this.datos = found.pagos
          this.loading = false
        }
      },
      getDatosCuota (idDetalleDerecho) {
        this.datos = []
        this.$store.dispatch('axiosMod/getData', { url: '/api/detalle_derecho/pagos/' + idDetalleDerecho })
          .then(response => {
            const cuota = {
              numeroCuota: idDetalleDerecho,
              pagos: response,
            }
            this.datos = cuota.pagos
            this.cuotas.push(cuota)
            this.loading = false
          })
      },
      generarNumero (item) {
        return (('00000000' + item.numeroRecibo).slice(-8))
      },
      montoMoneda (item) {
        return (item.simboloMoneda + ' ' + item.monto)
      },
    },
  }
</script>
